module.exports = __webpack_public_path__ + "img/小弹窗.5aba4ffc.jpg";